const BASE_URL = process.env.BASE_URL || "/";
const streamServer = process.env.VUE_APP_STREAMING_SERVER || "/";
const fileServer = process.env.VUE_APP_FILE_SERVER || "/";
const xRegisWestern = process.env.VUE_APP_XREGIS_WESTERN_WEBAPP || "https://xregis.western.ac.th";
const xRegisNation = process.env.VUE_APP_XREGIS_NATION_WEBAPP || "https://xregis.nation.ac.th";


import {getECode, getRStage} from "@/utils/auth-data";

// const e_code = !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).e_code;
// const r_stage = !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).r_stage;

export const config = {
  fileExtension: {
    csv: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    video: 'video/*',
    images: 'image/*',
    document: 'image/*,.csv,' +
      ' application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
      ' application/vnd.ms-excel,' +
      ' .doc,' +
      ' .docx,' +
      ' .pdf,' +
      ' application/vnd.ms-powerpoint,' +
      ' application/mspowerpoint,' +
      ' application/x-mspowerpoint,' +
      ' application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  url: {
    vdoOnDemandApi: `${streamServer}/upload`,
    vdoIntroductionApi: `${streamServer}/upload`,
    liveVdoApi: `${streamServer}upload-vdo-live-set`,
    uploadFiles: `${fileServer}/upload`,
    uploadAvatar: `${fileServer}/upload`,
    downloadFile: `${fileServer}/`,
    // downloadFile: `${fileServer}/${getECode()}/${getRStage()}/`,
    // downloadFile: `${fileServer}/${e_code}/${r_stage}/`,

    noAvatarImage: BASE_URL + 'static/images/no-avatar.png',
    noPhotoImage: BASE_URL + 'static/images/NoPhotoAvailable.jpg',
    xRegisWestern,
    xRegisNation,
  },
  prefixFileName: {
    vdoOnDemand: 'ODM',
    vdoIntroduction: 'VID',
    vdoLiveSet: 'VLS'
  },
  operationName:{
    teacherAvatar: 'image-upload',
    studentAvatar: 'image-upload',
    classAssignment: 'document-upload',
    studentAssignment: 'document-upload',
    classMaterial: 'document-upload',
    courseOutline: 'image-upload',
  },
  baseUrl: BASE_URL,
  streamServer: streamServer,
};

export function getAvatarUrl(picturePath){
  if(picturePath){
    return `${config.url.downloadFile}${getECode()}/${getRStage()}/${picturePath}`;
  }else{
    return BASE_URL + 'static/images/no-avatar.png'
  }
}
export function getXRegisStudentPhoto(studentId){
  if(studentId){
    const xRegisUrl = getECode() === 'x-studi-nation' ? xRegisNation:xRegisWestern
    return `${xRegisUrl}/stdphoto/${studentId}`;
  }else{
    return BASE_URL + 'static/images/no-avatar.png'
  }
}

export function getPhotoUrl(picturePath){
  if(picturePath){
    // return config.url.downloadFile  + picturePath;
    return `${config.url.downloadFile}${getECode()}/${getRStage()}/${picturePath}`;
  }else{
    return BASE_URL + 'static/images/NoPhotoAvailable.jpg'
  }
}

export function getClassRoomUrl(picturePath){
  if(picturePath){
    // return config.url.downloadFile  + picturePath;
    return `${config.url.downloadFile}${getECode()}/${getRStage()}/${picturePath}`;
  }else{
    return BASE_URL + 'static/images/classroom-placeholder.jpg'
  }
}
